import React from "react";
import SelectedTableData from "./SelectedTableData";
import SelectionsTableData from "./SelectionsTableData";

type Props = {
  HandleNext: () => void;
  HandleBack: () => void;
  ActiveStep: number;
};

function BOM(props: Props) {
  return (
    <>
      <SelectionsTableData />
      <SelectedTableData
        HandleNext={props.HandleNext}
        HandleBack={props.HandleBack}
        ActiveStep={props.ActiveStep}
      />
    </>
  );
}

export default BOM;
